import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { useTranslation } from "react-i18next";
import { Divider, Spinner } from "@nextui-org/react";
import { ItemContainer } from "./ItemContainer";
import React, { useEffect, useState } from "react";
import { useApi } from "../Context/ApiProvider";

// Main CategoryList component
export default function CatregoryList() {
  const api = useApi();
  const { t } = useTranslation();
  const [categories, setCategories] = useState([]);
  const [loadingPage, setLoadingPage] = useState(false);

  useEffect(() => {
    (async () => {
      setLoadingPage(true);
      const resCategories = await api.uget("/api/shop/categories?");
      if (resCategories.ok && resCategories.body?.results) {
        const fetchedCategories = resCategories.body.results.map(
          (category) => ({
            id: category.id,
            topic: category.title,
            text: category.description,
            image: category.image ? category.image.url : null,
          })
        );
        setCategories(fetchedCategories);
      }
      setLoadingPage(false);
    })();
  }, [api]);

  return (
    <>
      {loadingPage ? (
        <Spinner size="lg" className="flex justify-center mt-80 " />
      ) : (
        <div className="  bg-primary-800  relative top-28 md:top-0    ">
          <div className="flex flex-col items-center justify-center">
            <h2 className=" text-white text-2xl xl:text-4xl mt-6 xl:mt-14">
              {t("categortlisttitle")}
            </h2>
            <Divider className="w-40 xl:w-72 h-1 bg-red-600 mx-auto  mt-2 xl:mt-5 " />
          </div>

          <div className=" px-5  py-8 flex items-center ">
            <Swiper
              dir="rtl"
              breakpoints={{
                320: { slidesPerView: 1, spaceBetween: 10 },
                480: { slidesPerView: 2, spaceBetween: 15 },
                768: { slidesPerView: 3, spaceBetween: 30 },
                1280: { slidesPerView: 4, spaceBetween: 30 },
                1440: { slidesPerView: 5, spaceBetween: 30 },
              }}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
              }}
              loop={true}
              navigation={true}
              modules={[Navigation, Autoplay, Pagination]}
              pagination={{ dynamicBullets: true }}
              className="  cursor-pointer  swiper-category "
            >
              {categories.map((item) => (
                <SwiperSlide key={item.id} className="mb-7 ">
                  <ItemContainer
                    img={item.image}
                    topic={item.topic}
                    text={item.text}
                    itemid={item.id}
                    isSmall={true}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      )}
    </>
  );
}
